// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Tutorial_TrackInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /tutorial/track
 *
 * Validates tutorial tracking events. The slug is whitelist-validated
 * against the same VALID_SLUGS list used by the frontend tutorialService.js.
 * The action determines which model method runs; 'step' additionally uses
 * the optional `step` field.
 */
import { registerContract } from './validate'

export interface Tutorial_TrackInput {
slug: string
action: string
step?: number
}

registerContract('Tutorial_TrackInput', {
  slug:   { type: 'string',  required: true },
  action: { type: 'string',  required: true },
  step:   { type: 'number',  required: false },
})
